module.exports = __webpack_public_path__ + "static/praise-476c59befefa63f3cecb4f0681c8945e.gif";